(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('SurveyResponseDialogController', SurveyResponseDialogController);

    SurveyResponseDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'SurveyResponse', 'BatteryTest', 'Patient', 'Question'];

    function SurveyResponseDialogController ($scope, $stateParams, $uibModalInstance, entity, SurveyResponse, BatteryTest, Patient, Question) {
        var vm = this;
        vm.surveyResponse = entity;
        vm.batterytests = BatteryTest.query();
        vm.patients = Patient.query();
        vm.questions = Question.query();
        vm.load = function(id) {
            SurveyResponse.get({id : id}, function(result) {
                vm.surveyResponse = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('ipmApp:surveyResponseUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.surveyResponse.id !== null) {
                SurveyResponse.update(vm.surveyResponse, onSaveSuccess, onSaveError);
            } else {
                SurveyResponse.save(vm.surveyResponse, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
